/* eslint-disable import/prefer-default-export */
export const fetal = [
    {
        normal: `ECOCARDIOGRAMA FETAL (NORMAL)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Septo interventricular íntegro, ausência de “shunts” pela análise de fluxo por mapeamento de cores.

VALVAS:
Valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT --- mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual. Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
ECOCARDIOGRAMA FETAL NORMAL PARA A IDADE GESTACIONAL

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        alterado: `ECOCARDIOGRAMA FETAL (ALTERADO)

Idade gestacional referida:  --- semanas e --- dia(s).
Idade gestacional estimada (pelo exame):  --- semanas e --- dia(s).

1-	Situs: solitus em levocardia.
2-	Conexão atrioventricular: concordante.
3-	Conexão ventrículo-arterial: concordante.
4-	Veias pulmonares: visibilizado ao menos duas veias pulmonares drenando em átrio esquerdo.
5-	Drenagem sistêmica: visibilizado VCS e VCI drenando em átrio direito.
6-	Septo interatrial: forame oval de aspecto normal, membrana abaulada para a esquerda, sem restrição ao fluxo.
7-	Valvas:
    •	Mitral: aspecto normal.
    •	Tricúspide: aspecto normal.
    •	Aórtica: aspecto normal. Fluxo normal com velocidade sis. máx: --- cm/s.
    •	Pulmonar: aspecto normal. Fluxo normal com velocidade sis. máx: --- cm/s.
8-	Septo interventricular: íntegro.
9-	Função contrátil: biventricular preservada.
10-	Cavidades:
    •	Átrios: tamanhos normais para a idade gestacional.
    •	Ventrículos: tamanhos normais para a idade gestacional. Vias de saída sem obstruções.
11-	Arco aórtico: morfologia normal e à esquerda.
12-	Artéria pulmonar: morfologia normal, ramos pulmonares de aspecto habitual.
13-	Canal arterial: patente; aspecto normal com fluxo da artéria pulmonar para o arco aórtico.
14-	Ritmo cardíaco: regular; condução AV 1:1, FC mínima de --- bpm e máxima de --- bpm.

CONCLUSÃO:
Exame de boa qualidade técnica.
Exame dentro da normalidade para a idade gestacional.

*Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
**O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. (Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        t4f: `ECOCARDIOGRAMA FETAL (T4F)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Presença de comunicação ampla em septo interventricular (--- mm), com extensão para via de saída, apresentando fluxo bidirecional ao mapeamento a cores.

VALVAS:
Valva pulmonar de diâmetro reduzido com restrição de mobilidade e abertura.
Valva aórtica dextroposta e com “overriding” < 50%, abertura e mobilidade preservadas. 
As demais valvas cardíacas apresentam mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT ---mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres --- para a idade gestacional.
TP --- mm (---z),  APD --- mm (---z) e APE --- (---z).

AORTA:
Arco aórtico à esquerda/direita, apresenta calibre e morfologia habitual.

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
TETRALOGIA DE FALLOT.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre à 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        sceh: `ECOCARDIOGRAMA FETAL (SCEH)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo univentricular. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo sem restrição ao fluxo.
Septo interventricular íntegro, ausência de “shunts” pela análise de fluxo por mapeamento de cores.

VALVAS:
Valvas mitral e aórtica hipoplásicas, com mobilidade e abertura reduzidas.
As demais valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT --- mm (---z).

CAVIDADES:
Átrios com morfologia e dimensões habituais. Ventrículo esquerdo pequeno, medindo no eixo longitudinal --- mm (---z) e no eixo curto --- mm (---z). 
Ventrículo direito predominante, medindo no eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.
AP --- mm (---z), APD --- mm (---z) e APE --- mm (---z).

AORTA:
Arco aórtico à esquerda, apresentando redução de calibre em aorta ascendente e parte de arco transverso. Apresenta fluxo sistólico anterógrado. Istmo aórtico (sagital) --- mm (---z), (3VV) --- mm (---z), Ao ascendente --- mm (---z), transverso --- mm (---z) e Ao descendente --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
SÍNDROME DA HIPOPLASIA DO CORAÇÃO ESQUERDO.
HIPOPLASIA DAS VALVAS AÓRTICA E MITRAL.
FORAME OVAL SEM PADRÃO DE RESTRIÇÃO.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        dsavt: `ECOCARDIOGRAMA FETAL (DSAVT)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo via de entrada comum. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Presença de fluxo bidirecional por análise de mapeamento a cores em septo interatrial próximo à valva AV comum, compatível com comunicação interatrial “Ostium Primum” medindo --- mm.
Fluxo bidirecional por análise de mapeamento a cores em septo interventricular, compatível com uma comunicação interventricular ampla de via de entrada (por ausência do septo AV) medindo --- mm.

VALVAS:
Valva atrioventricular única, com abertura comum aos dois ventrículos de forma balanceada. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
As valvas aórtica e pulmonar apresentam mobilidade e abertura preservadas, com análise de fluxo por mapeamento de cores e Doppler sem alterações.
VP --- mm (---z) e VT ---mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional.
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.
AP --- mm (---z), APD --- mm (---z) e APD --- mm (---z).

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual.
Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).
Ao ascendente --- mm (---z), transverso --- mm (---z) e Ao descendente --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
DEFEITO DO SEPTO ATRIOVENTRICULAR TOTAL, FORMA BALANCEADA.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        coao: `ECOCARDIOGRAMA FETAL (COAO)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com qualidade técnica ---, Ritmo cardíaco sinusal, FC --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Septo interventricular íntegro, ausência de “shunts” pela análise de fluxo por mapeamento de cores.

VALVAS:
Valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VT --- mm (---z) e VP --- mm (---z).

CAVIDADES:
Ventrículo direito com dimensões aumentadas em relação ao VE.
Demais câmaras com morfologia e dimensões habituais para a idade gestacional.
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).
VE: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.
AP --- mm (---z), APD --- mm (---z) e APE --- mm (---z).

AORTA:
Arco aórtico à esquerda, apresenta istmo de calibre reduzido, medindo --- mm (---z) no eixo sagital e --- mm (---z) no “corte" dos 3VV. Análise do fluxo demostrando padrão contínuo ao mapeamento a cores.
Ao ascendente --- mm (---z), transverso --- mm (---z) e Ao descendente --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
HIPOPLASIA DE ISTMO AÓRTICO COM POSSIBILIDADE DE COARCTAÇÃO DE AORTA.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        civ: `ECOCARDIOGRAMA FETAL (CIV)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Presença de fluxo bidirecional por análise de mapeamento a cores em septo interventricular, compatível com uma comunicação interventricular --- medindo --- mm.

VALVAS:
Valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT ---mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual.

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
COMUNICAÇÃO INTERVENTRICULAR ---.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre à 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        tga: `ECOCARDIOGRAMA FETAL (TGA)

Idade gestacional referida: --- semanas e --- dia(s).

Situs: “sólitus” em levocardia.

Conexão atrioventricular: concordante.
Conexão ventrículo-arterial: discordante.

Veias pulmonares: observadas ao menos duas veias pulmonares drenando em átrio esquerdo.
Drenagem sistêmica: observadas VCS e VCI drenando em átrio direito.
Septro interatrial: forame oval de aspecto normal, membrana abaulada para a esquerda, sem restrição ao fluxo.

VALVAS:
Mitral: aspecto normal.
Tricúspide: aspecto normal.
Aórtica: anterior e à direita, com aspecto normal. Fluxo normal com velocidade sistólica máxima de --- cm/s.
Pulmonar: posterior e à esquerda, com aspecto normal. Fluxo normal com velocidade sistólica máxima de --- cm/s.

Septo interventricular: íntegro.
Função contrátil: biventricular preservada.

CAVIDADES:
Átrios: tamanhos normais para a idade gestacional.
Ventrículos: tamanhos normais para a idade gestacional. Vias de saída dos ventrículos emergindo paralelamente em posição de D-TGA, sem obstruções.

Arco aórtico: bem visualizado, com morfologia normal e à esquerda.
Artéria pulmonar: morfologia normal, ramos pulmonares de aspecto habitual.
Canal arterial: patente, com aspecto normal e fluxo da artéria pulmonar para o arco aórtico.

Ritmo cardíaco: regular; condução AV 1:1, FC de --- bpm.

CONCLUSÃO:
Exame de boa qualidade técnica.
Transposição das grandes artérias (D-TGA simples).

*Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.

**O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional.
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    // novos
    {
        dtga: `ECOCARDIOGRAMA FETAL (D-TGA)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com qualidade técnica ---, Ritmo cardíaco sinusal, FC --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Há discordância ventrículo-arterial com a artéria aorta emergindo do ventrículo direito e a pulmonar do ventrículo esquerdo.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo com fluxo sem sinais de restrição.
Septo interventricular íntegro, ausência de “shunts” pela análise de fluxo por mapeamento de cores.

VALVAS:
Valvas cardíacas apresentam mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
Valva aórtica com localização anterior e a direita e valva pulmonar posterior e a esquerda.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT --- mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional.
Vias de saída dos ventrículos direito e esquerdo emergindo paralelamente em posição de transposição, sem sinais de obstrução.
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).
VE: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.
AP --- mm (---z), APD --- mm (---z) e APE --- mm (---z).

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual.
Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).
Ao ascendente --- mm (---z), transverso --- mm (---z) e Ao descendente --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
TRANSPOSIÇÃO DAS GRANDES ARTÉRIAS (d-TGA).
FORAME OVAL SEM SINAIS DE RESTRIÇÃO.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        ltga: `ECOCARDIOGRAMA FETAL (L-TGA)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular discordante com discordância ventrículo arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo sem restrição ao fluxo.
Septo interventricular íntegro, ausência de “shunts” pela análise de fluxo por mapeamento de cores.

VALVAS:
Valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT ---mm (---z).

CAVIDADES:
Átrios com morfologia e dimensões habituais para a idade gestacional.
Ventrículos em posição de transposição, com cavidade apresentando banda moderadora e valva tricúspide localizada à esquerda.
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Emerge do ventrículo esquerdo localizado à direita, com tronco e ramos pulmonares com calibres normais para a idade gestacional.
AP --- mm (---z), APD --- mm (---z) e APD --- mm (---z).

AORTA:
Emerge do ventrículo direito localizado à esquerda, com Arco aórtico à esquerda, apresenta calibre e morfologia habitual. 
Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).
Ao ascendente --- mm (---z), transverso --- mm (---z) e Ao descendente --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
TRANSPOSIÇÃO CONGENITAMENTE CORRIGIDA DAS GRANDES ARTÉRIAS (L-TGA).
FORAME OVAL SEM SINAIS DE RESTRIÇÃO.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        dvsvdTaussig: `ECOCARDIOGRAMA FETAL (DVSVD Taussig-Bing)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Conexão ventrículo arterial com dupla via de saída do ventrículo direito.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Presença de fluxo com “shunt” VE-VD em septo interventricular, compatível com comunicação interventricular ampla com extensão para via de saída, --- mm.

VALVAS:
Nota-se valva aórtica à direita da valva pulmonar, cavalgando o septo interventricular em mais de 50%, apresenta mobilidade e abertura preservadas.
As demais valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT --- mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional. Dupla via de saída do ventrículo direito, com a aorta e a pulmonar emergindo em paralelo (vasos transpostos), sem sinais de obstrução ao fluxo.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual. Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
DUPLA VIA DE SAÍDA DO VENTRÍCULO DIREITO TIPO “TAUSSIG-BING”.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        dvsvd: `ECOCARDIOGRAMA FETAL (DVSVD)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Conexão ventrículo arterial com dupla via de saída do ventrículo direito.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Presença de fluxo com “shunt” VE-VD em septo interventricular, compatível com comunicação interventricular ampla com extensão para via de saída, --- mm.

VALVAS:
Nota-se valva aórtica à esquerda da valva pulmonar, cavalgando o septo interventricular em mais de 50%, apresenta mobilidade e abertura preservadas.
As demais valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT --- mm (---z).

CAVIDADES:
Átrios e ventrículos com morfologia e dimensões habituais para a idade gestacional. Via de saída do ventrículo esquerdo ausente, com aorta e pulmonar emergindo ambas do ventrículo direito, sem sinais de obstrução ao fluxo.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual. Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
DUPLA VIA DE SAÍDA DO VENTRÍCULO DIREITO.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).

`,
    },
    {
        ebstein: `ECOCARDIOGRAMA FETAL (Ebstein)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia. Cardiomegalia, [com / sem] sinais de hidropsia fetal e [presença / ausência] de derrame pericárdico.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo biventricular concordante. Há concordância ventrículo-arterial.

SEPTOS:
Forame oval de aspecto normal, lâmina da fossa oval abaulada para o átrio esquerdo.
Septo interventricular íntegro, ausência de “shunts” pela análise de fluxo por mapeamento de cores.

VALVAS:
Valva tricúspide com importante alteração de sua morfologia e implantação, com deslocamento apical dos folhetos septal e posterior, em relação ao plano do anel valvar mitral, medindo --- mm/m². Folheto anterior alongado e redundante, com mobilidade --- e aspecto --- [em “vela” / habitual].  Apresenta insuficiência valvar de grau ---, com jato direcionado ---. Velocidade máxima do jato regurgitante: --- m/s.

Valva pulmonar [anatomicamente preservada / hipoplásica], com fluxo [anterógrado reduzido / ausente]. Não se observam sinais de obstrução valvar pulmonar significativa [Ausência de fluxo anterógrado significativo através da valva pulmonar, achado que pode corresponder a atresia pulmonar funcional no contexto da importante insuficiência tricúspide.]

Demais valvas cardíacas apresentando mobilidade e abertura preservadas. Análise de fluxo por mapeamento de cores e Doppler sem alterações.
VA --- mm (---z), VM --- mm (---z), VP --- mm (---z) e VT ---mm (---z).

CAVIDADES:
Átrio direito com dilatação ---. 
Ventrículo direito com atrialização do segmento basal, com porção funcional do ventrículo de dimensões ---.
Átrio e ventrículo esquerdo com morfologia e dimensões habituais para a idade gestacional.
VD: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).
VE: eixo longitudinal --- mm (---z) e eixo curto --- mm (---z).
Índice de Celermajer (GOSE): --- [<0,5 / 0,5 - 0,99 / 1,00 - 1,49 / ≥ 1,50] (Grau [1-4]).

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres normais para a idade gestacional.

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia habitual. Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
ANOMALIA DE EBSTEIN.
INSUFICIÊNCIA TRICÚSPIDE DE GRAU ---.
[PRESENÇA / AUSÊNCIA] DE CARDIOMEGALIA E [PRESENÇA / AUSÊNCIA] DE DISFUNÇÃO VENTRICULAR.
FLUXO PULMONAR ANTERÓGRADO [PRESERVADO / REDUZIDO / AUSENTE].
[SEM / -] SINAIS DE HIDROPSIA FETAL.


Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        atresiaI: `ECOCARDIOGRAMA FETAL (Atresia Tricúspide I)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo univentricular por ausência de via de entrada à direita. Há concordância ventrículo-arterial.

SEPTOS:
Presença de comunicação interatrial ampla com “shunt” AD-AE.
Fluxo bidirecional por análise de mapeamento a cores em septo interventricular, compatível com uma comunicação interventricular ---, medindo --- mm.

VALVAS:
Nota-se ausência de valva tricúspide com presença tecido fibromuscular, compatível com atresia tricúspide.
Valva mitral com dimensões ---, apresentando abertura e mobilidade ---.
Valva aórtica ---.
Valva pulmonar ---.
VA --- mm (---z), VP --- mm (---z) e VM --- mm (---z).

CAVIDADES:
Átrio e ventrículo direito de dimensões reduzidas, com dilatação das câmaras esquerdas. Vias de saída aórtica e pulmonar --- sinais de obstrução.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar. Fração de encurtamento: ---.

ARTÉRIA PULMONAR:
Tronco e ramos pulmonares com calibres --- para a idade gestacional.

AORTA:
Arco aórtico à esquerda, apresenta calibre e morfologia ---. Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
ATRESIA TRICÚSPIDE TIPO I---.
COMUNICAÇÃO INTERATRIAL ---.
COMUNICAÇÃO INTERVENTRICULAR ---.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
    {
        atresiaII: `ECOCARDIOGRAMA FETAL (Atresia Tricúspide II)

IG ---: --- semanas e --- dia(s). IG por biometria fetal: --- semanas e --- dia(s).
Exame realizado com ---. Ritmo cardíaco sinusal, FC: --- bpm.

Situs solitus em levocardia.
Drenagem venosa sistêmica e pulmonar habituais.
Conexão atrioventricular do tipo univentricular por ausência de via de entrada à direita. Há discordância ventrículo-arterial.

SEPTOS:
Presença de comunicação interatrial ampla com “shunt” AD-AE.
Fluxo bidirecional por análise de mapeamento a cores em septo interventricular, compatível com uma comunicação interventricular ---, medindo --- mm.

VALVAS:
Nota-se ausência de valva tricúspide com presença tecido fibromuscular, compatível com atresia tricúspide.
Valva mitral com dimensões ---, apresentando abertura e mobilidade ---.
Valva aórtica ---.
Valva pulmonar ---.
VA --- mm (---z), VP --- mm (---z) e VM --- mm (---z).

CAVIDADES:
Átrio e ventrículo direito de dimensões reduzidas, com dilatação das câmaras esquerdas. Vias de saída aórtica e pulmonar --- sinais de obstrução.

FUNÇÃO VENTRICULAR:
Ambos os ventrículos apresentam função contrátil normal do ponto de vista global e segmentar. Fração de encurtamento: ---.

ARTÉRIA PULMONAR:
Emerge do ventrículo esquerdo. Tronco e ramos pulmonares com calibres --- para a idade gestacional.

AORTA:
Emerge do ventrículo direito. Arco aórtico à esquerda, apresenta calibre e morfologia ---. Istmo aórtico (sagital): --- mm (---z); (3VV): --- mm (---z).

DUCTO ARTERIOSO:
Possui calibre adequado. Análise de fluxo ao Doppler com índices e velocidades habituais e “shunt” AP-AO.

DUCTO VENOSO:
Análise Doppler apresenta fluxo de velocidades adequadas.

CONCLUSÃO:
ATRESIA TRICÚSPIDE TIPO II---.
COMUNICAÇÃO INTERATRIAL ---.
COMUNICAÇÃO INTERVENTRICULAR ---.

Alterações como coarctação de aorta, drenagem anômala de veias pulmonares, comunicação interventricular pequena e comunicação interatrial podem ser de difícil definição diagnóstica ao exame.
O período ideal para realizar o exame é entre a 24ª e 28ª semana gestacional. 
(Fonte: Diretriz de atualização da ASE de 2023; Diretriz Brasileira de Cardiologia Fetal de 2019).
`,
    },
];